import styled from "styled-components";

export const Container = styled.div`
  width: 35%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  height: 90vh;
  background-color: ${({ outlineColor }) => outlineColor};
  border-left: 1px solid;
  border-image: linear-gradient(180deg, #ffffff 0%, #b7b7b7 50%, #ffffff 100%);
  border-image-slice: 1;
`;

export const Boxheader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.5vw;
  padding: 0 1.25rem;
`;

export const Box = styled.div`
  flex: 1;
  background-color: #ffffff;
  height: calc(100% - 3.5vw);
`;
